import MainSocket from './MainSocket';

export default new MainSocket();
